import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-patient-information-modal',
  templateUrl: './patient-information-modal.component.html',
  styleUrls: ['./patient-information-modal.component.scss']
})
export class PatientInformationModalComponent implements OnInit {
@Input()
  ordonnance: any;
@Output()
  private modalPatientInformations: EventEmitter<boolean> = new EventEmitter();

  public afficherEnvoieSMS = false;

  constructor() { }

  ngOnInit(): void {
    this.modalPatientInformations.emit(true);
  }

  closeModal() {
    this.modalPatientInformations.emit(false);
  }

  afficherModalSMS() {
    this.afficherEnvoieSMS = true;
  }

  changeAfficherModalSMS(event){
    this.afficherEnvoieSMS = event;
  }

}
